/** @param {boolean} isOutline */
export function planUsageOutlineButtonSx(isOutline) {
  return {
    minWidth: 0,
    px: '8px',
    py: 0,
    height: isOutline ? 20 : 28,
    minHeight: isOutline ? 20 : 28,
    borderRadius: '6px',
    fontSize: '0.75rem',
    fontWeight: 590,
    lineHeight: '20px',
    letterSpacing: 0,
    color: 'text.primary',
    textTransform: 'none',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    ...(isOutline
      ? { bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }
      : { bgcolor: 'background.default', border: 'none' }),
  }
}
